/**
 * Les adresses du parcours d'apprentissage.
 *
 * Un seul endroit, parce que ces chemins sont écrits à trois endroits qui ne se
 * voient pas : les liens de l'écran, les canoniques des métadonnées et le plan
 * du site. Trois copies auraient fini par diverger, et une canonique qui ne
 * pointe pas là où le lien mène désindexe la page qu'elle prétend désigner.
 *
 * On adresse par l'identifiant de fichier (`premiers-sons`) et non par l'UUID :
 * un UUID ne se lit pas, ne se partage pas et ne se référence pas. L'API
 * accepte les deux, l'écran n'en emploie qu'un.
 */

export const LEARN_BASE_PATH = "/learn";

export function learnProgramPath(vpfId: string): string {
  return `${LEARN_BASE_PATH}/${encodeURIComponent(vpfId)}`;
}

export function learnExercisePath(vpfId: string, vefId: string): string {
  return `${learnProgramPath(vpfId)}/${encodeURIComponent(vefId)}`;
}
